import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { BaseFormViewComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { FormEnums } from "models/enums";
import { FileConstants } from "utils/constants";
import { DocumentFormTypes } from "models/formTypes";
import { FileHelper } from "utils/helpers";
//#endregion
//#region components
import { GenericForm } from "components/common";
//#endregion

const UploadDocumentForm: ForwardRefRenderFunction<FormHandles, BaseFormViewComponentProps> = (props, ref) => {
  return (
    <GenericForm<DocumentFormTypes.UploadSharedDocument>
      formRef={ref}
      {...props}
      fields={{
        files: {
          label: "",
          type: FormEnums.FormFieldType.FILEUPLOADER,
          extraProps: {
            fileUploaderType: "full",
            allowedTypes: FileHelper.getSharedDocumentTypes(),
            filePreviewElementId: FileConstants.DialogFilePreviewPortalId,
          },
        },
      }}
      hideSuccess
    />
  );
};

export default forwardRef(UploadDocumentForm);
